export default __webpack_public_path__ + "static/media/reportsendcollectionmgr-hover.78298f86.svg";